import { render, staticRenderFns } from "./Tipologieintervento.vue?vue&type=template&id=b638fcee&"
import script from "./Tipologieintervento.vue?vue&type=script&lang=ts&"
export * from "./Tipologieintervento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports